import styled from 'styled-components';

export const FitContent = styled.div`
    width: fit-content;
`;

export const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
